import { render, staticRenderFns } from "./ResourceSummary.vue?vue&type=template&id=6b39849d&scoped=true&"
import script from "./ResourceSummary.vue?vue&type=script&lang=js&"
export * from "./ResourceSummary.vue?vue&type=script&lang=js&"
import style0 from "./ResourceSummary.vue?vue&type=style&index=0&id=6b39849d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b39849d",
  null
  
)

export default component.exports